var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u5BA2\u670D\u70ED\u7EBF") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "10\\u65B0\\u95FB\\u52A8\\u6001-\\u8BE6\\u60C5",
    transform: "translate(-464, -1919)",
    fill: "#7D9CC2",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-2",
    transform: "translate(0, 1841)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u5BA2\\u670D\\u70ED\\u7EBF",
    transform: "translate(464, 78)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10,0 C4.5,0 0,4.5 0,10 C0,15.5 4.5,20 10,20 C15.5,20 20,15.5 20,10 C20,4.5 15.5,0 10,0 Z M14.75,13.75 L14.25,14.25 L14.125,14.375 L14,14.5 C13.375,15.125 11.25,16 7.5,12.375 C4,8.875 5,6.75 5.5,6.125 L6.375,5.25 C6.75,4.875 7.375,4.875 7.75,5.25 L9,6.5 C9.375,6.875 9.375,7.5 9,7.875 L8.25,8.5 L8.125,8.75 C7.75,9.125 7.75,9.25 8.25,9.75 L10.125,11.5 C11,12.25 11.125,12.25 11.5,12 L12.125,11.25 C12.5,10.875 13.125,10.75 13.5,11.125 L14.75,12.375 C15.125,12.75 15.125,13.375 14.75,13.75 L14.75,13.75 Z",
    id: "\\u5F62\\u72B6"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.265908c35c9b1e9c6d83398383a8a410.svg";
export { ForwardRef as ReactComponent };